// extracted by mini-css-extract-plugin
export default {"container":"CustomerActivities_container__A8p6D","noDataAvailable":"CustomerActivities_noDataAvailable__7GRcJ"};